export type AuftragsTyp = 'unfall' | 'autoglas';

export interface AuftragsTypOption {
  id: AuftragsTyp;
  label: string;
  emoji: string;
  beschreibung: string;
  color: string;
  bgColor: string;
}

export interface KioskStepDef {
  id: string;
  label: string;
}

export const ANIMATION_DURATION_MS = 300;

export const TILE_MIN_SIZE = 180;

export const AUFTRAGSTYP_OPTIONS: AuftragsTypOption[] = [
  {
    id: 'unfall',
    label: 'Unfallschaden',
    emoji: '🚗',
    beschreibung: 'Kfz-Gutachten, Haftpflicht, Wertgutachten',
    color: '#1E5FB7',
    bgColor: '#EFF6FF',
  },
  {
    id: 'autoglas',
    label: 'Steinschlag / Glasschaden',
    emoji: '🪟',
    beschreibung: 'Windschutzscheibe, Seitenscheibe, Heckscheibe',
    color: '#3DB54A',
    bgColor: '#F0FDF4',
  },
];

const UNFALL_STEPS: KioskStepDef[] = [
  { id: 'auftragstyp',        label: 'Auftragstyp' },
  { id: 'fahrzeugschein',     label: 'Fahrzeugschein' },
  { id: 'unfallbericht',      label: 'Unfallbericht' },
  { id: 'fuehrerschein',      label: 'Führerschein' },
  { id: 'fahrzeug',           label: 'Fahrzeug' },
  { id: 'schadenfotos',       label: 'Schadenfotos' },
  { id: 'kontakt',            label: 'Kontakt' },
  { id: 'bankkarte',          label: 'Bankkarte' },
  { id: 'gutachtenversand',   label: 'Versand' },
  { id: 'datenbestaetigen',   label: 'Daten prüfen' },
  { id: 'zusatzfragen',       label: 'Zusatzfragen' },
  { id: 'demontage',          label: 'Demontage' },
  { id: 'details',            label: 'Details' },
  { id: 'anwalt',             label: 'Anwalt' },
  { id: 'auftrag',            label: 'Unterschrift' },
  { id: 'bewertung',          label: 'Bewertung' },
  { id: 'instagram',          label: 'Social Media' },
  { id: 'complete',           label: 'Fertig' },
];

// Autoglas is a shorter flow — no rating/social steps (handled at counter)
const AUTOGLAS_STEPS: KioskStepDef[] = [
  { id: 'auftragstyp',        label: 'Auftragstyp' },
  { id: 'fahrzeugschein',     label: 'Fahrzeugschein' },
  { id: 'fuehrerschein',      label: 'Führerschein' },
  { id: 'fahrzeug',           label: 'Fahrzeug' },
  { id: 'schadenfotos',       label: 'Schadenfotos' },
  { id: 'kontakt',            label: 'Kontakt' },
  { id: 'bankkarte',          label: 'Bankkarte' },
  { id: 'gutachtenversand',   label: 'Versand' },
  { id: 'datenbestaetigen',   label: 'Daten prüfen' },
  { id: 'zusatzfragen',       label: 'Zusatzfragen' },
  { id: 'details',            label: 'Details' },
  { id: 'anwalt',             label: 'Anwalt' },
  { id: 'auftrag',            label: 'Unterschrift' },
  { id: 'complete',           label: 'Fertig' },
];

export function getStepsForTyp(typ: AuftragsTyp | ''): KioskStepDef[] {
  if (typ === 'autoglas') return AUTOGLAS_STEPS;
  return UNFALL_STEPS;
}
